"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullScreenStateProvider = exports.FullScreenStateContext = void 0;
var React = __importStar(require("react"));
var use_fullscreen_1 = require("../../hooks/use-fullscreen");
exports.FullScreenStateContext = React.createContext(null);
var FullScreenStateProvider = function (_a) {
  var _b = _a.initialState,
    initialState = _b === void 0 ? {} : _b,
    children = _a.children;
  var _c = __read((0, use_fullscreen_1.useFullScreen)(), 2),
    isFullScreen = _c[0],
    _d = _c[1],
    exitFull = _d.exitFull,
    setFull = _d.setFull,
    toggleFull = _d.toggleFull;
  var value = {
    isFullScreen: isFullScreen,
    isSplitScreen: false,
    enterFullScreen: setFull,
    exitFullScreen: exitFull,
    toggleFullScreen: toggleFull
  };
  return React.createElement(exports.FullScreenStateContext.Provider, {
    value: value
  }, children);
};
exports.FullScreenStateProvider = FullScreenStateProvider;